import serverSideRender from './server-side-render';

export  {
    serverSideRender
};



// WEBPACK FOOTER //
// ./serverMiddleWares/index.js